import { useToast } from "@chakra-ui/react";
import uuid from "react-uuid";

interface IToastProps {
  title: string;
  message?: string;
}

const useToastService = () => {
  const toast = useToast();

  const id = uuid();

  const showSuccessTaost = ({ title, message }: IToastProps) => {
    if (!toast.isActive(id)) {
      toast({
        id: id,
        title: title,
        description: message,
        variant: "solid",
        position: "top-right",
        isClosable: true,
        status: "success",
        duration: 3000,
      });
      return;
    } else {
      toast.closeAll();
    }
  };
  const showInfoToast = ({ title, message }: IToastProps) => {
    if (!toast.isActive(id)) {
      toast({
        id: id,
        title: title,
        description: message,
        variant: "solid",
        position: "top-right",
        isClosable: true,
        status: "info",
        duration: 9000,
      });
      return;
    } else {
      toast.closeAll();
    }
  };
  const showErrorToast = ({ title, message }: IToastProps) => {
    if (!toast.isActive(id)) {
      toast({
        id: id,
        title: title,
        description: message,
        variant: "solid",
        position: "top-right",
        isClosable: true,
        status: "error",
        duration: 3000,
      });
      return;
    } else {
      toast.closeAll();
    }
  };
  return {
    showErrorToast,
    showSuccessTaost,
    showInfoToast,
  };
};

export { useToastService };
